import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DomManipulationService {
  private _renderer: Renderer2;

  constructor(private _rendererFactory: RendererFactory2) {
    this._renderer = this._rendererFactory.createRenderer(null, null);
  }

  public prependHeader(container: any, headerTag: string): void {
    if (container && !container.querySelector(headerTag)) {
      const header = this._renderer.createElement(headerTag);
      const firstChild = container.firstChild;

      if (firstChild) {
        this._renderer.insertBefore(container, header, firstChild);
      } else {
        this._renderer.appendChild(container, header);
      }
    }
  }

  public addBodyClass(className: string): void {
    const body = document.body;
    this._renderer.addClass(body, className);
  }

  public removeBodyClass(className: string): void {
    const body = document.body;
    this._renderer.removeClass(body, className);
  }
}
